import { AgenturNameCell } from 'app/components/shared/AgenturName.cell';
import { Table } from 'app/components/table/table';
import { AggregrationType, ITableColumn, TableModel, TableRow } from 'app/components/table/table.model';
import { useStore } from 'app/context';
import { observer } from 'mobx-react';
import { useEffect, useState } from 'react';
import { AgtLinkedinVM } from 'app/stores/ui/agt.linkedin.ui.store';
import { Icon } from 'app/components/common/Icon';
import { formatNum, formatNumTwoDig } from 'app/utils';
import { LinkedinBmRangeOptions } from './SocialMediaOptions';

export const LinkedInListe = observer(() => {
	const { berichteUiiStore, agtLinkedinUiStore, agenturListUiStore } = useStore();
	const [hasItems, setHasItems] = useState(false);
	const tm = new TableModel<AgtLinkedinVM, number>();
	const cols: ITableColumn<AgtLinkedinVM, number>[] = [];

	const currentYear = agtLinkedinUiStore.currentYear;

	cols.push({
		label: 'Agentur',
		path: 'agt.name',
		sortBy: 'agt.name',
		render: AgenturNameCell,
	});

	cols.push({
		label: 'Link',
		path: 'currLinkedin.url',
		sortBy: 'currLinkedin.url',
		render: (row: TableRow<AgtLinkedinVM>) => {
			return row.data.currLinkedin && row.data.currLinkedin.url ? (
				<a href={row.data.currLinkedin.url} className="color-primary" target="_blank" rel="noreferrer">
					<Icon iconClass="external-link" />
				</a>
			) : (
				<></>
			);
		},
	});

	cols.push({
		label: 'Status',
		path: `currLinkedin.status`,
		sortBy: `currLinkedin.status`,
		agg: [{ aggType: AggregrationType.count }],
		render: (row: TableRow<AgtLinkedinVM>) => <>{row.data.currLinkedin && row.data.currLinkedin.status === 1 ? <Icon iconClass="check" /> : ''}</>,
	});

	cols.push({
		label: 'Follower',
		path: `currFollower`,
		sortBy: `currFollower`,
		agg: [{ aggType: AggregrationType.avg }],
		format: formatNum,
	});

	cols.push({
		label: 'Follower VJ',
		path: `prevFollower`,
		sortBy: `prevFollower`,
		agg: [{ aggType: AggregrationType.avg }],
		format: formatNum,
	});

	cols.push({
		label: `Beiträge ${currentYear}`,
		path: `postsYtd`,
		sortBy: `postsYtd`,
		agg: [
			{
				aggType: AggregrationType.avg,
				format: formatNumTwoDig,
			},
		],
		format: formatNum,
	});

	cols.push({
		label: `Sichtkontakte ${currentYear}`,
		path: `viewsYtd`,
		sortBy: `viewsYtd`,
		agg: [{ aggType: AggregrationType.avg }],
		format: formatNum,
	});

	cols.push({
		label: `Erreichte Personen ${currentYear}`,
		path: `reachYtd`,
		sortBy: `reachYtd`,
		agg: [{ aggType: AggregrationType.avg }],
		format: formatNum,
	});

	tm.sortBy = 'agt.name';
	tm.setCols(cols);

	tm.idProperty = 'agtId';
	tm.idType = 'number';

	useEffect(() => {
		agtLinkedinUiStore.loadBySelectedRange().then((vms) => {
			let items = vms.filter((x) => x.linkedins.length > 0);
			if (berichteUiiStore.selectedAgt) {
				const agtId = berichteUiiStore.selectedAgt.agtId;
				items = items.filter((i) => i.agt.agtId === agtId);
			} else {
				items = agenturListUiStore.applyFilterOnAgt(items) as AgtLinkedinVM[];
			}
			setHasItems(items.length > 0);
			tm.setRowData(items);
			tm.sort();
		});
	}, [tm, berichteUiiStore.selectedAgt, agenturListUiStore.filterHasChanged, agenturListUiStore, agtLinkedinUiStore, agtLinkedinUiStore.selectedMinBm, agtLinkedinUiStore.selectedMaxBm]);

	return (
		<>
			<LinkedinBmRangeOptions />
			{!hasItems ? (
				<div className="pad-1rem">Keine Daten gefunden</div>
			) : (
				<>
					<Table stickyHeader={true} tm={tm} stickyFooter={true}></Table>
				</>
			)}
		</>
	);
});
